module.exports = __webpack_public_path__ + "img/forward_icon_Inno.94a7fefd.svg";